import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "./pages/HomePage";
import IdeasPage from "./pages/IdeasPage";
import IdeaDetailPage from "./pages/IdeaDetailPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import AdminIdeas from "./pages/AdminIdeas";
import AdminInquiries from "./pages/AdminInquiries";
import AdminSettings from "./pages/AdminSettings";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import LiabilityPage from "./pages/LiabilityPage";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css";

function App() {
  return (
    <div className="App min-h-screen bg-slate-950 flex flex-col">
      <BrowserRouter>
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: '#0f172a',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#e2e8f0',
            },
          }}
        />
        <Routes>
          {/* Public routes with Navbar/Footer */}
          <Route path="/" element={<><Navbar /><HomePage /><Footer /></>} />
          <Route path="/ideas" element={<><Navbar /><IdeasPage /><Footer /></>} />
          <Route path="/ideas/:id" element={<><Navbar /><IdeaDetailPage /><Footer /></>} />
          
          {/* Legal pages */}
          <Route path="/terms" element={<><Navbar /><TermsPage /><Footer /></>} />
          <Route path="/privacy" element={<><Navbar /><PrivacyPage /><Footer /></>} />
          <Route path="/liability" element={<><Navbar /><LiabilityPage /><Footer /></>} />
          
          {/* Admin login without Navbar/Footer */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          
          {/* Protected admin routes */}
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/ideas" element={<ProtectedRoute><AdminIdeas /></ProtectedRoute>} />
          <Route path="/admin/inquiries" element={<ProtectedRoute><AdminInquiries /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
